import '@/util/webpackPublicPath';
import Vue from 'vue';
import i18n from './i18n';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueLazyload from 'vue-lazyload';
import 'swiper/dist/css/swiper.css';
// 使得 local-global.scss 优先级低于 app.vue
import '../../style/local-global.scss';
import App from './App.vue';

Vue.use(VueAwesomeSwiper);

Vue.use(VueLazyload, {
  preLoad: location.href.indexOf('localhost:800') > -1 ? 1 : 6,
  attempt: 1,
  lazyComponent: true,
  observer: true,

  // optional
  observerOptions: {
    rootMargin: location.href.indexOf('localhost:800') > -1 ? '0px 0px 0px 0px' : '5000px 5000px 5000px 5000px'
  },
  filter: {
    // 先切换webp再切换CDN
    webp(listener, options) {
      const el = listener.el;
      if (!options.supportWebp || !el.dataset || !el.dataset.webp) return;
      listener.src = el.dataset.webp;
    }
    // changeCDN(listener) {
    //   if (location.href.indexOf('localhost:800') > -1) return;
    //   // 静态资源切换回cdn，对于生产环境。
    //   const isCdn = /feature\/static/;
    //   if (process.env.VUE_APP_PUBLICPATH.indexOf(listener.src) === -1 && isCdn.test(listener.src)) {
    //     listener.src = process.env.VUE_APP_PUBLICPATH + listener.src;
    //     // listener.src = 'https://static01.coloros.com/www' + listener.src;
    //   }
    // }
  }
});

new Vue({
  i18n,
  render: h => h(App)
}).$mount('#app');

// 监控badejs的加载
if (
  process.env.NODE_ENV === 'production' &&
  location.href.indexOf('localhost:800') === -1 &&
  process.env.VUE_APP_SITETYPE !== 'foreign'
) {
  import(/* webpackChunkName: "heyTapOReportEventTrack" */ '@heytap/oreport-eventtrack').then(heTapOTrack => {
    const oTrack = heTapOTrack.default;
    const track = new oTrack({
      id: process.env.VUE_APP_STAGING ? 339 : 344,
      appKey: process.env.VUE_APP_STAGING ? 'f19d95b1f0509f244337c2df7cd7830a' : '85b59f6e7f05a5184ebd5fdfb49310c5'
    });
    track.trackPageView({ pageId: 'coloros11' });
    window.heyTapOReportEventTrack = track;
  });
  import('@heytap/oreport').then(heytapOreport => {
    const OReport = heytapOreport.default;
    const oreport = new OReport({
      id: process.env.VUE_APP_STAGING ? 339 : 344,
      appKey: process.env.VUE_APP_STAGING ? 'f19d95b1f0509f244337c2df7cd7830a' : '85b59f6e7f05a5184ebd5fdfb49310c5',
      console: true,
      delay: 1 * 1000,
      random: 1,
      beforeReport: () => {
        return true;
      }
    });
    if (location.hostname !== 'localhost' && location.hostname !== '127.0.0.1') {
      oreport.installVueErrorHandler(Vue);
    }
  });
}

if (!!window.ActiveXObject || 'ActiveXObject' in window) {
  // fixed 布局在 ie11 下，因为 z-index 问题会出现抖动情况，需要采用模拟滚动
  // 只是刷新就到了顶部，没有记录当前轮动位置
  document.body.addEventListener &&
    document.body.addEventListener(
      'mousewheel',
      function() {
        event.preventDefault();
        var wd = event['wheelDelta'];
        var csp = window.pageYOffset;
        window.scrollTo(0, csp - wd);
      },
      { passive: true }
    );
}
